import { IVendorSearchFilterDTO, IMassMailingLogSearchFilterDTO } from 'wisestep-api';

export const vendorsSearchDefaultQuery: IVendorSearchFilterDTO = {
  page: 0,
  size: 50,
  query: '',
  sort: ['createdOn,desc'],
};

export const massMailingLogSearchDefaultQuery: IMassMailingLogSearchFilterDTO = {
  query: '',
  toEmails: [],
  firstRecordsOnly: true,
  massMailingGroupId: '',
  createdBy: [],
  createdFromDate: '',
  createdToDate: '',
  page: 0,
  size: 50,
  sort: ['createdOn,desc'],
};
export const vendorListTabs = [
  { tabName: 'All' },
  { tabName: 'Valid' },
  { tabName: 'Invalid' },
  { tabName: 'Unknown' },
  { tabName: 'Validation Pending' },
];
export interface Credits {
  balance: number;
  used: number;
}
